module.exports = __webpack_public_path__ + "153da1f116515b73c5f2ae8a30fb90ed.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/laptop.png
// module id = 3017
// module chunks = 0